import React, { Component } from 'react';

// Styles
import '../../styles/LoginPage.scss';

// Material UI
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import { VpnKey } from '@material-ui/icons';
import FormControl from '@material-ui/core/FormControl';

// Local
import DotLoader from '../shared/dot-loader';
import SuccessRedirect from '../shared/success-redirect';
import { oktaErrorService } from '../../services/oktaError.service';
import { PASSWORD_REQUIREMENTS } from '../../constants/password';
import axios from 'axios';

type MyProps = {
  goBack: any,
  app: string,
  redirectUrl: string,
  tempPassword: string,
  stateToken: string,
  login: any,
  username: string
};
type MyState = {
  formControls: {
    newPassword: string,
    confirmPassword: string,
  },
  errors: {
    login: string,
    passwordReset: string[]
  },
  success: boolean,
  loading: boolean,
};

class ResetTempPassword extends Component<MyProps, MyState> {
  constructor(props: any) {
    super(props);
    this.state = {
      formControls: {
        newPassword: '', confirmPassword: '',
      },
      errors: {
        login: '',
        passwordReset: []
      },
      success: false,
      loading: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.goBackToSignIn = this.goBackToSignIn.bind(this);
  }

  handleSubmit(event: any) {
    event.preventDefault();
    if (this.state.formControls.newPassword !== this.state.formControls.confirmPassword) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          passwordReset: ['Passwords do not match.']
        }
      });
      return;
    }
    this.setState({
      ...this.state,
      loading: true
    });
    this.setNewPassword();
  }

  goBackToSignIn = () => {
    this.props.goBack();
  }

  async setNewPassword() {
    const baseUrl = process.env['REACT_APP_API_URL'];
    await axios.post(`${baseUrl}/password/`, {
      userInfo: this.props.username,
      oldPassword: this.props.tempPassword,
      newPassword: this.state.formControls.newPassword,
      stateToken: this.props.stateToken,
      app: this.props.app,
      redirectUrl: this.props.redirectUrl,
    }).then((res: any) => {
      if (res.data.errorSummary) {
        const passwordResetErrorMessages = oktaErrorService(res.data) as string[];
        this.setState({
          ...this.state,
          loading: false,
          errors: {
            ...this.state.errors,
            passwordReset: passwordResetErrorMessages
          }
        });
      } else {
        this.setState({
          ...this.state,
          loading: false,
          success: true,
        });
        localStorage.setItem('sessionToken', res.data.sessionToken);
        window.location.href = res.data.redirectUrl;
      }
    });
  }

  handleChange(event: any) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      ...this.state,
      errors: {
        login: '',
        passwordReset: []
      },
      formControls: {
        ...this.state.formControls,
        [name]: value
      },
    });
  }

  renderTempPassword() {
    return (
      <div className="login-input">
        <div className='password-requirements-container'>
          <div className='password-requirements-header'>Reset your LightHouse password</div>
          <div className='password-requirements'>
            <div>Password Requirements:</div>
            <ul>
              {PASSWORD_REQUIREMENTS.map((requirement: string, index: number) => {
                return <li key={index}>{requirement}</li>
              })}
            </ul>
          </div>
        </div>
        <form onSubmit={this.handleSubmit} className="login-input">
          <FormControl className="form-box" >
            <TextField
              id="password"
              label="New Password"
              required
              name="newPassword"
              value={this.state.formControls.newPassword}
              onChange={this.handleChange}
              margin="normal"
              variant="outlined"
              type="password"
              placeholder="New Password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <VpnKey />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              id="confirmPassword"
              label="Confirm Password"
              required
              name="confirmPassword"
              value={this.state.formControls.confirmPassword}
              onChange={this.handleChange}
              margin="normal"
              variant="outlined"
              type="password"
              placeholder="Confirm Password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <VpnKey />
                  </InputAdornment>
                ),
              }}
            />
            {!this.state.loading ?
              <div className="button-container">
                <Button
                  type="submit"
                  name="continue"
                  variant="contained"
                  size="large"
                  classes={{ label: 'button-label' }}
                  className="button">
                  Reset Password
                </Button>
              </div> : null}
          </FormControl>
          <div className="error-messages">
            {this.state.errors.passwordReset.map((error: string, index: number) =>
              <div key={index}>{error}</div>)}
          </div>
        </form>
        {this.state.loading ? <DotLoader /> : <button className="back-button" onClick={this.goBackToSignIn}>Back to Sign In</button>}
      </div >
    );
  }

  render() {
    return (
      <div className="login-input">
        {!this.state.success ? this.renderTempPassword() : <SuccessRedirect />}
      </div>
    );
  }
}

export default ResetTempPassword;
